import React from "react";
import styled from "styled-components";

import { DeviceTicket } from "@state/types";
import { colorsRGB } from "@util/constants";
import { getTicketSeatDetails } from "@util/ticketDetails";

const Details = styled.div`
  overflow-wrap: anywhere;
`;

const Label = styled.div`
  color: ${colorsRGB.white(0.7)};
  font-size: 12px;
  line-height: 1.4;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

const TicketType = styled.div<{ $compact: boolean }>`
  font-size: ${({ $compact }) => ($compact ? 22 : 28)}px;
  line-height: 1.15;
  margin: 4px 0 12px;
`;

const Zone = styled.div`
  font-size: 18px;
  line-height: 1.3;
  margin-top: 4px;
`;

const Seats = styled.dl`
  display: grid;
  gap: 12px;
  margin: 16px 0 0;

  dt {
    color: ${colorsRGB.white(0.7)};
    font-size: 12px;
    line-height: 1.4;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  dd {
    font-size: 22px;
    line-height: 1.2;
    margin: 4px 0 0;
  }
`;

export default function TicketDetails({
  ticket,
  compact = false,
}: {
  ticket: DeviceTicket;
  compact?: boolean;
}) {
  const { section, row, seat } = getTicketSeatDetails(ticket);

  return (
    <Details>
      <Label>{ticket.isEventAddon ? "Add-on type" : "Ticket type"}</Label>
      <TicketType $compact={compact}>
        {(ticket.isEventAddon
          ? ticket.eventAddonName
          : ticket.ticketTypeName) || "-"}
      </TicketType>
      {ticket.seatZone && (
        <>
          <Label>Zone</Label>
          <Zone>{ticket.seatZone}</Zone>
        </>
      )}
      {(section || row || seat) && (
        <Seats>
          {section && (
            <div>
              <dt>Section</dt>
              <dd>{section}</dd>
            </div>
          )}
          {row && (
            <div>
              <dt>Row</dt>
              <dd>{row}</dd>
            </div>
          )}
          {seat && (
            <div>
              <dt>Seat</dt>
              <dd>{seat}</dd>
            </div>
          )}
        </Seats>
      )}
    </Details>
  );
}
